// extracted by mini-css-extract-plugin
module.exports = {"root":"template-icon_root__1Tnxi"};